export const ApplyResult = {
    NotHandle: '0',
    NotPass: '1',
    Pass: '2',
};

export interface IApplyInfo {
    /**
     * 是否已经申请过编辑权限了
     */
    hasApplied: boolean;
    /**
     * 申请结果。对应ApplyResult状态
     */
    applyResult: string;
}

/**
 * 权限申请相关服务
 */
export interface IApplyAuthService {
    // 是否已经申请编辑权限
    hasApplied: boolean;
    // 权限申请状态信息
    applyInfo: IApplyInfo;
    /**
     * 初始化，会触发申请状态信息拉取
     */
    init(): Promise<void>;
    /**
     * 触发申请编辑权限动作
     */
    handleApplyEdit(): void;

    /**
     * 是否可以申请编辑权限
     */
    canApplyEdit(): boolean;

    /**
     * 拉取24小时内的权限申请状态
     * @param domainId  文档信息
     * @param padId
     */
    checkIsApplyIn24H(domainId: string, padId: string): Promise<IApplyInfo>;
}
